import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Permission } from "ui/Scripts/source/models/enums";
import { useRef } from "react";
import { PopupMenu } from "source/components/framework/PopupMenu";
import { RemoveToolButton } from "source/components/framework/Button/RemoveToolButton";
import { EditToolButton } from "source/components/framework/Button/EditToolButton";
import { PrintToolButton } from "source/components/framework/Button/PrintToolButton";
import { DownloadToolButton } from "source/components/framework/Button/DownloadToolButton";
import { CopyToolButton } from "source/components/framework/Button/CopyToolButton";

interface IDocumentListLinePopuMenuProps {
    editMode: boolean;
    folderPermission: Permission;
    isSelected: boolean;
    canDownloadSelectedDocuments: boolean;
    canPrintSelectedDocuments: boolean;
    onCopyMoveSelectedDocuments: () => void;
    onOpenSelectedDocument: () => void;
    onDownloadSelectedDocuments: () => void;
    onPrintSelectedDocuments: () => void;
    onDeleteSelectedDocuments: () => Promise<void>;
}

export const DocumentListLinePopuMenu = (props: IDocumentListLinePopuMenuProps) => {
    const deleting = useRef<boolean>(false);

    if (!props.isSelected) return null;

    const handleDelete = async () => {
        if (deleting.current) return;
        deleting.current = true;
        try {
            await props.onDeleteSelectedDocuments();
        } finally {
            deleting.current = false;
        }
    };

    return (
        <PopupMenu
            right={"35px"}
        >
            {props.editMode && props.folderPermission > Permission.Read &&
                <EditToolButton tooltip={Translations.DocumentProperties} onClick={props.onOpenSelectedDocument}/>
            }
            {props.canDownloadSelectedDocuments &&
                <DownloadToolButton tooltip={Translations.DownloadDocument} onClick={props.onDownloadSelectedDocuments} />
            }
            {props.canPrintSelectedDocuments &&
                <PrintToolButton onClick={props.onPrintSelectedDocuments} />
            }
            <CopyToolButton tooltip={Translations.CopyOrMoveFilesDocuments} onClick={props.onCopyMoveSelectedDocuments} />
            {props.editMode && props.folderPermission > Permission.Read &&
                <RemoveToolButton tooltip={Translations.RemoveDocument} onClick={handleDelete} />
            }
        </PopupMenu>
    );
};